import WelcomeMessage from './WelcomeMessage/WelcomeMessage'
import SalesAgentBonusStats from './SalesAgentsBonusStats/SalesAgentsBonusStats'
import TopSalesAgents from './SalesAgentsBonusStats/TopSalesAgents'
import useHome from './useHome'
import useHomeStyles from './useHomeStyles'
import SpeedFormation from './SpeedFormation/SpeedFormation'
import { Gamification } from './Gamification'

const Home = () => {
  const { data, isLoading, isExternal, country, type, t } = useHome()
  const { cardStyle, cardBonuses, headingStyle, parent, child } = useHomeStyles()

  if (isLoading || !data) {
    return (
      <div className={cardStyle}>
        <p>{t('common:fetching_data')}</p>
      </div>
    )
  }

  return (
    <>
      <div className={parent} id='home-welcome'>
        <div className={cardStyle + child}>
          <h1 className={headingStyle}>{t('home:home_welcome')}</h1>
          <WelcomeMessage />
        </div>
        {!isExternal && (
          <div className={cardStyle + child}>
            <h1 className={headingStyle}>{t('home:speed_formation.title')}</h1>
            <SpeedFormation />
          </div>
        )}
      </div>

      <Gamification cardStyle={cardStyle} />

      {!data.isAdmin && (
        <div className={cardBonuses}>
          <h1 className={headingStyle}>{t('home:bonus_summary')}</h1>
          <SalesAgentBonusStats />
        </div>
      )}

      {type === 'energie' && country === 'fr' && (
        <div className={cardStyle}>
          <h1 className={headingStyle}>{t('home:bonus_top_agents_primes')}</h1>
          <TopSalesAgents />
        </div>
      )}
    </>
  )
}

export default Home
